import React, {Component} from 'react';
import Navigation from './Navigation';
import Footer from './Footer';


class Main extends Component {
  render() {
    return (
      <div>
        <div id="wrap">
          <div id="main">
            <header>
              <Navigation/>
            </header>
            <div className="uk-container">
              {this.props.children}
            </div>
          </div>
          <div className="uk-padding-small"></div>
        </div>
        <footer>
          <div className="uk-section-small bg-footer">
            <div className="uk-container">
              <Footer/>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// src/components/Main.js